import Vue from 'vue'
// 只添加复用性很高的方法
const common = {
  // 获取参数
  query: function (name, urlStr) {
    var url = urlStr || location.href;
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || ['', ''])[1].replace(/\+/g, '%20')) || false;
  },
  save(item, str, type = 0) {
    if (typeof (str) === 'object') {
      str = JSON.stringify(str);
    }
    if (type == 0) {
      sessionStorage.removeItem(item);
      sessionStorage[item] = str;
    } else {
      localStorage.removeItem(item);
      localStorage[item] = str;
    }
  },
  get(item, type = 0) {
    var value = null;
    if (type == 0) {
      if (sessionStorage[item] !== undefined) {
        value = sessionStorage[item];
        if (value.indexOf('{') === 0 || value.indexOf('[') === 0) {
          value = JSON.parse(value);
        }
      }
      return value;
    } else {
      if (localStorage[item] !== undefined) {
        value = localStorage[item];
        if (value.indexOf('{') === 0 || value.indexOf('[') === 0) {
          value = JSON.parse(value);
        }
      }
      return value;
    }
  },
  extend(old, newObj, cover) {
    if (old instanceof Array) {
      old = old.concat(newObj);
    } else {
      for (var p in newObj) {
        if (newObj.hasOwnProperty(p) && (!old.hasOwnProperty(p) || cover)) {
          old[p] = newObj[p];
        }
      }
    }
    return old;
  },
  remove(item = -1, type = 0) {
    if (type == 0) {
      if (item === -1) {
        sessionStorage.clear();
      } else {
        sessionStorage.removeItem(item);
      }
    } else {
      if (item === -1) {
        localStorage.clear();
      } else {
        localStorage.removeItem(item);
      }
    }
  },

  userDate(uData, type) {
    var myDate = new Date(uData * 1000);
    var year = t(myDate.getFullYear());
    var month = t(myDate.getMonth() + 1);
    var day = t(myDate.getDate());
    var hours = t(myDate.getHours());
    var minutes = t(myDate.getMinutes());
    var second = t(myDate.getSeconds());
    var str = '';
    if (type) {
      switch (type) {
        case 'yyyy':
          str = year;
          break;
        case 'yyyy-MM':
          str = year + '-' + month;
          break;
        case 'yyyy-MM-dd':
          str = year + '-' + month + '-' + day;
          break;
        case 'yyyy-MM-dd hh:mm':
          str = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes;
          break;
        default:
          str = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + second;
          break;
      }
    } else {
      str = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + second;
    }
    return str;

    function t(time) {
      if (time < 10) {
        return '0' + time;
      } else {
        return time;
      }
    }
  },
  thisTimes: function (type, de) {
    var d = de || new Date();
    var y = d.getFullYear();
    var m = d.getMonth() + 1;
    var dd = d.getDate();
    var day = d.getDay(); // 星期几
    var h = d.getHours(); // 时
    var f = d.getMinutes(); // 分
    var s = d.getSeconds(); // 秒
    dd = dd < 10 ? '0' + dd : dd;
    day = day < 10 ? '0' + day : day;
    y = y < 10 ? '0' + y : y;
    m = m < 10 ? '0' + m : m;
    h = h < 10 ? '0' + h : h;
    f = f < 10 ? '0' + f : f;
    s = s < 10 ? '0' + s : s;
    var json = '';

    switch (type) {
      case 'yy':
        json = y;
        break;
      case 'mm':
        json = m;
        break;
      case 'dd':
        json = dd;
        break;
      case 'hh':
        json = h;
        break;
      case 'ff':
        json = f;
        break;
      case 'ss':
        json = s;
        break;
      case 'day':
        json = day;
        break;
      case 'days':
        json = new Date(d.getFullYear(), (d.getMonth() + 1), 0).getDate();
        break;
      case 'yyyy':
        json = y;
        break;
      case 'yyyy-MM':
        json = y + '-' + m;
        break;
      case 'MM-dd':
        json = y + '-' + m + '-' + dd;
        break;
      case 'yyyy-MM-dd':
        json = y + '-' + m + '-' + dd;
        break;
      case 'yyyy-MM-dd HH:MM':
        json = y + '-' + m + '-' + dd + ' ' + h + ':' + f;
        break;
      case 'yyyy-MM-dd HH:MM:SS':
        json = y + '-' + m + '-' + dd + ' ' + h + ':' + f + ':' + s;
        break;
      case 'HH:MM':
        json = h + ':' + f;
        break;
      case 'HH:MM:SS':
        json = h + ':' + f + ':' + s;
        break;
      default:
        json = y + '-' + m + '-' + dd + ' ' + h + ':' + f + ':' + s;
        break;
    }
    return json;
  },
  parseParam(json) {
    var params = Object.keys(json).map(function (key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
    }).join('&');
    return params;
  },
  debounce(method, delay) { // 去抖
    // (停止改变n毫秒后执行) 可用在窗口改变大小 window.onresize 、监听input输入的时候
    var timer = null;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        method.apply(context, args);
      }, delay);
    };
  },

  isWeiXin: function () {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) === 'micromessenger') {
      return true;
    } else {
      return false;
    }
  },
  wait(time = 2000) {
    return new Promise(async (resolve) => {
      setTimeout(() => {
        resolve();
      }, time);
    });
  },
  getDivHeight(el) {
    let winHeight = this.getWinHeight();
    let height = winHeight - el.offsetHeight;
    return height;
  },
  bodyAddBg(name) {
    var className = name || 'bg';
    document.getElementsByTagName('body')[0].className = className;
  },
  removeBodyBg() {
    document.getElementsByTagName('body')[0].className = '';
  },

  isIOS: function () {
    var ua = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod/.test(ua)) {
      return true;
    } else { //  android/.test(ua)
      return false;
    }
  },
  getBrowser() {
    var browser = navigator.userAgent.toLowerCase();
    if (browser.match(/Alipay/i) == 'alipay') { //eslint-disable-line
      return 'pay';
    } else if (browser.match(/MicroMessenger/i) == 'micromessenger') { //eslint-disable-line
      return 'wx';
    } else if (window.api) {
      return 'app';
    } else {
      return 'other';
    }
  },
  goBack(num) {
    let i = num || -1;
    history.go(i);
  },
  innerHeight: 0,
  getWinHeight() {
    let innerHeight = this.innerHeight !== 0 ? this.innerHeight : window.innerHeight;
    let contentHeight = innerHeight - 0;
    return contentHeight;
  },
  isEmpty(obj) {
    return !obj || obj === ''
  },
  /**
   * 获取当月的第一天
   */
  getCurrentMonthFirst() {
    let date = new Date();
    date.setDate(1);
    return date;
  },
  /**
   * 获取当月的第一天
   */
  compareDate(date1, date2) {
    return date1.getTime() - date2.getTime();
  },
  /**
   * 获取当年的第一天
   */
   yearFristDate() {
    let date = new Date();
    var tYear = date.getFullYear()

    return new Date(tYear,0,1);
  },
  /**
   * 获取显示的时间段
   */
  getCurrentTimeRange(value, originValue, title) {
    let valueArray = [];
    if (originValue && originValue.details && originValue.details.length) {
      valueArray = originValue.details;
    }
    return `${title}(${this.getTargetTimeRange(value, valueArray)})`;
  },
  /**
   * 获取费率对应的时间段
   */
  getTargetTimeRange(value, valueArray) {
    for (let i = 0; i < valueArray.length; i++) {
      let item = valueArray[i];
      if (item.slotElecPrice == value) {
        return `${this.formatDelayTime(item.beginTime)}～${this.formatDelayTime(item.endTime)}`
      }
    }
    return '-'
  },
  wrapFee(value) {
    if (value && !value.hasTimeType) {
      value.details = [];
      value.details.push({
        beginTime: 0,
        endTime: 2400,
        slotElecPrice: value.slotElecPrice,
        slotServicePrice: value.slotServicePrice,
      });
    }
    return value
  },
  wrapDelayFee(value) {
    //如果是单一费率则自己把数据放入details数组统一处理
    if (value && !value.hasTimeType) {
      value.details = [];
      value.details.push({
        beginTime: 0,
        endTime: 2400,
        slotDelayPrice: value.slotDelayPrice,
      });
    }
    return value
  },
  addZero(num) {
    return num > 9 ? num : '0' + num;
  },
  formatDelayTime(time) {
    if (!time && typeof time !== 'number') {
      return '-'
    }
    return `${this.addZero(parseInt(time/100))}:${this.addZero(time%100)}`;
  },
  checkOrderIsAbnormal(router, status) {
    if (status === 4) {
      Vue.prototype.$dialog.alert({
        title: '订单异常',
        confirmButtonText: '确认',
        confirmButtonColor: '#14CC80',
        closeOnPopstate: true
      }).then(() => {
        // router.replace({name: 'home2'});
        router.go(-1);
      }).catch(() => {});
    }
  },
  showTargetDialog(dialog, router, data, isNeedBack = true, accountPkId) {
    if (data.data[0].errorType === 1) {
      // 余额不足
      dialog.confirm({
        message: data.msg,
        confirmButtonText: '充值',
        confirmButtonColor: '#14CC80',
        closeOnPopstate: true
      }).then(() => {
        // on confirm
        router.push({
          name: 'recharge'
        });
      }).catch(() => {
        // on cancel
        if (isNeedBack) {
          router.go(-1);
        }
      });
    } else if (data.data[0].errorType === 3) {
      // 账号异常
      dialog.alert({
        message: data.msg,
        confirmButtonColor: '#14CC80',
        closeOnPopstate: true
      }).then(() => {
        // on confirm
        if (isNeedBack) {
          router.go(-1);
        }
      });
    } else if (data.data[0].errorType === 2) {
      // 充电站异常
      dialog.confirm({
        message: data.msg,
        confirmButtonText: '反馈',
        confirmButtonColor: '#14CC80',
        closeOnPopstate: true
      }).then(() => {
        // on confirm
        router.replace({
          name: 'feedback',
          replace: true
        });
      }).catch(() => {
        if (isNeedBack) {
          router.go(-1);
        }
      });
    } else if (data.data[0].errorType === 4) {
      // 其他异常
      dialog.alert({
        message: '账户有未支付的订单，请先支付',
        confirmButtonText: '确定',
        confirmButtonColor: '#14CC80',
        closeOnPopstate: true
      }).then(() => {
        router.push({
          name: 'my/order',
          query: {
            accountPkId: accountPkId,
            orderState: 1
          }
        });
      });
    } else if (data.data[0].errorType === 5) {
      // 充电枪异常
      dialog.confirm({
        message: data.msg,
        confirmButtonText: '反馈',
        confirmButtonColor: '#14CC80',
        closeOnPopstate: true
      }).then(() => {
        // on confirm
        router.replace({
          name: 'feedback'
        });
      }).catch(() => {
        if (isNeedBack) {
          router.go(-1);
        }
      });
    }
  },
  copyText(text,call){
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {//区分iPhone设备  
        var span = document.createElement('span');
          span.innerHTML = text;
          //span.style.display='none';
          span.id='copyTextSpan';
          document.body.appendChild(span);
          window.getSelection().removeAllRanges();//这段代码必须放在前面否则无效  
          var range = document.createRange();  
          // 选中需要复制的节点  
          range.selectNode(span);  
          // 执行选中元素  
          window.getSelection().addRange(range);  
          // 执行 copy 操作  
          document.execCommand('copy');  

          // 移除选中的元素  
          window.getSelection().removeAllRanges(); 
          span.parentNode.removeChild(span);
          call && call();
    }else{
      var oInput = document.createElement('input');
        oInput.value = text;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        oInput.className = 'oInput';
        oInput.style.display='none';
        oInput.parentNode.removeChild(oInput);
        call && call();
    }
      
  },
  codeMsg(code){
    if(code != null){
      return '【' + code +'】'
    }else {
      return '';
    }
  }
};

export default common;